import { render, staticRenderFns } from "./CallAddIssues.vue?vue&type=template&id=4c974156"
import script from "./CallAddIssues.vue?vue&type=script&lang=js"
export * from "./CallAddIssues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports